// @ts-nocheck

import { createSelector } from 'reselect';

import { __ } from '../../i18n/l10n';
import { selectBasketMode } from '../../selectors/basket/basketPrimary.selector';
import { selectBasketEnhancedItems, getNbItems } from '../../selectors/basketItems.selector';
import { selectEntitiesMatches } from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { BasketModes } from '../../types/basket';

const selectAllRelatedMatches = createSelector([selectBasketEnhancedItems], (items) => {
  return Object.keys(
    items.reduce((acc, item) => {
      if (item.matchId) {
        acc[item.matchId] = 1;
      }
      return acc;
    }, {}),
  );
});

const selectRuntimeIsMyMatchEnabled = createSelector(
  [selectAllRelatedMatches, selectEntitiesMatches],
  (relatedMatches, matches) =>
    relatedMatches.length === 1 ? matches[relatedMatches[0]]?.mymatchAvailable ?? false : false,
);

const selectDisplayMyMatchLabel = createSelector(
  [getNbItems, selectRuntimeIsMyMatchEnabled, selectBasketMode],
  (nbItems, isMyMatchEnabled, basketMode) => {
    if (basketMode === BasketModes.SIMPLE) {
      return nbItems > 1 ? isMyMatchEnabled : false;
    }
    return isMyMatchEnabled;
  },
);

const selectBasketTabsProps = createSelector(
  [selectBasketMode, getNbItems, selectDisplayMyMatchLabel, selectAllRelatedMatches],
  (mode, nbItems, isMyMatch, relatedMatches) => {
    return {
      tabs: [
        { id: BasketModes.SIMPLE, label: __('Single'), disabled: false },
        {
          id: BasketModes.COMBINED,
          label: isMyMatch ? 'MyMatch' : __('Accumulator'),
          disabled: nbItems < 2 && !isMyMatch,
        },
        { id: BasketModes.SYSTEM, label: __('System'), disabled: nbItems < 3 || relatedMatches.length < 3 },
      ],
      selected: mode,
    };
  },
);

export default selectBasketTabsProps;
